module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/_redefine.js
// module id = 550
// module chunks = 168707334958949